/** Indicador de carregamento inline. Para carregamento de página inteira, ver `.page-loading` em base.css. */
export interface SpinnerProps {
  label?: string;
  className?: string;
}

export function Spinner({ label = 'Carregando…', className }: SpinnerProps) {
  return (
    <span className={['row', className].filter(Boolean).join(' ')} role="status">
      <span className="spinner" aria-hidden="true" />
      <span className="muted">{label}</span>
    </span>
  );
}
